import { BaseApi } from '@/api/BaseApi.ts'
import type {
  BusinessData,
  BusinessFormData,
  BusinessFullData,
} from '@/api/Business/types.ts'
import type { Paginated, ParamType } from '@/api/types.ts'
import { api } from '..'

class Api extends BaseApi<
  BusinessFullData,
  Paginated<BusinessData>,
  BusinessFormData
> {
  readonly baseUrl = '/business'

  async toggleState(id: ParamType): Promise<void> {
    const url = `${this.baseUrl}/${id}/toggle-state`
    const { data } = await api.put<void>(url)
    return data
  }
}

const BusinessApi = new Api()

export default BusinessApi
